
import HeaderLayout from "@/components/layouts/Header.vue";
import FooterLayout from "@/components/layouts/Footer.vue";
import PaymentMethodsTable from "@/components/tables/PaymentMethods.vue";
import QuadrupleBlock from "@/components/blocks/Quadruple.vue";

export default {
  name: "FactuurView",
  components: {
    QuadrupleBlock,
    PaymentMethodsTable,
    HeaderLayout,
    FooterLayout,
  },
};
